import React, { useState } from "react";
import {
Box,
Card,
Typography,
TextField,
Button,
Stack,
MenuItem,
Checkbox,
FormControlLabel,
Snackbar,
Alert,
CircularProgress,
InputAdornment,
IconButton
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import { useLocation, useNavigate } from "react-router-dom";
import { Colors } from "../utils/colors";
import { adminFetch } from "../services/adminFetch";
import { adminPageSx } from "../utils/adminResponsive";

export default function ModifyAdmin(){

const { state } = useLocation();
const navigate = useNavigate();

const adminData = state?.admin;

const [formData,setFormData] = useState({
first_name: adminData?.first_name || "",
last_name: adminData?.last_name || "",
email: adminData?.email || "",
role: adminData?.role || "support_admin",
status: adminData?.status || "active",
password: ""
});

const [notify,setNotify] = useState(true);
const [loading,setLoading] = useState(false);
const [showPassword,setShowPassword] = useState(false);


const [snackbar,setSnackbar] = useState({
open:false,
message:"",
severity:"success"
});

const showSnackbar = (message,severity="success")=>{
setSnackbar({open:true,message,severity});
};

const handleCloseSnackbar = ()=>{
setSnackbar({...snackbar,open:false});
};


const update = (field,value)=>{
setFormData(prev=>({...prev,[field]:value}));
};




const handleUpdateAdmin = async () => {

setLoading(true);

try{

const data = await adminFetch("/api/admin/update",{
method:"PUT",
body: JSON.stringify({
admin_id: adminData.id,
...formData,
notify
})
});

if(!data.status){
showSnackbar(data.message || "Update failed","error");
setLoading(false);
return;
}

showSnackbar("Admin updated successfully");

setTimeout(()=>{
navigate("/admin/admins");
},1500);

}catch(err){
console.log(err);
showSnackbar("Server error","error");
}

setLoading(false);
};


return(

<Box sx={{ ...adminPageSx }}>

<Card sx={{ p:{ xs:2, sm:4 }, maxWidth:600 }}>

<Typography
variant="h5"
fontWeight={700}
sx={{color:Colors.accent, mb:3}}
>
Modify Admin
</Typography>

<Stack spacing={2}>

<TextField
label="First Name"
value={formData.first_name}
onChange={(e)=>update("first_name",e.target.value)}
fullWidth
/>

<TextField
label="Last Name"
value={formData.last_name}
onChange={(e)=>update("last_name",e.target.value)}
fullWidth
/>

<TextField
label="Email"
value={formData.email}
onChange={(e)=>update("email",e.target.value)}
fullWidth
/>

<TextField
select
label="Role"
value={formData.role}
onChange={(e)=>update("role",e.target.value)}
fullWidth
>
<MenuItem value="super_admin">Super Admin</MenuItem>
<MenuItem value="finance_admin">Finance Admin</MenuItem>
<MenuItem value="support_admin">Support Admin</MenuItem>
</TextField>

<TextField
select
label="Status"
value={formData.status}
onChange={(e)=>update("status",e.target.value)}
fullWidth
>
<MenuItem value="active">Active</MenuItem>
<MenuItem value="suspended">Suspended</MenuItem>
</TextField>

<TextField
label="New Password (optional)"
type={showPassword ? "text" : "password"}
value={formData.password}
onChange={(e)=>update("password",e.target.value)}
fullWidth
InputProps={{
endAdornment: (
<InputAdornment position="end">
<IconButton onClick={()=>setShowPassword((prev)=>!prev)} edge="end">
{showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
</IconButton>
</InputAdornment>
)
}}
/>

<FormControlLabel
control={
<Checkbox
checked={notify}
onChange={(e)=>setNotify(e.target.checked)}
/>
}
label={`Notify admin (${formData.email})`}
/>

<Button
variant="contained"
fullWidth
sx={{
backgroundColor:Colors.accent,
color:"#003300",
fontWeight:700,
mt:2
}}
onClick={handleUpdateAdmin}
disabled={loading}
>
{loading
? <CircularProgress size={22} sx={{color:"white"}}/>
: "Update Admin"}
</Button>

</Stack>

</Card>




<Snackbar
open={snackbar.open}
autoHideDuration={4000}
onClose={handleCloseSnackbar}
anchorOrigin={{vertical:"top",horizontal:"center"}}
>
<Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
{snackbar.message}
</Alert>
</Snackbar>

</Box>

);

}
